export default {
      Menus: 'قائمة النظام|قوائم النظام',
      Menus_no_body: 'قائمة نظام',
};
